const ListManagerTabType = {
  Oneil: "ONEIL",
  Ownership: "OWNERSHIP",
  External: "EXTERNAL"
};

export default ListManagerTabType;
